import { render } from "./WalletDashboard.vue?vue&type=template&id=ada145ca&scoped=true"
import script from "./WalletDashboard.vue?vue&type=script&lang=js"
export * from "./WalletDashboard.vue?vue&type=script&lang=js"

import "./WalletDashboard.vue?vue&type=style&index=0&id=ada145ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ada145ca"]])

export default __exports__